import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: `folder-name-input-${_ctx.externalIndex}`,
    class: "folder-name-input input-wrapper uk-flex"
  }, [
    _withDirectives(_createElementVNode("input", {
      ref: "folderNameInput",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
      class: "uk-input uk-form-small uk-margin-small-right uk-width-small",
      type: "text",
      placeholder: "Folder name",
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel')))
    }, null, 544), [
      [_vModelText, _ctx.value]
    ]),
    _createElementVNode("span", {
      "uk-icon": "icon: check; ratio: 0.8;",
      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveHandler && _ctx.saveHandler(...args)), ["stop"]))
    })
  ], 8, _hoisted_1))
}